import clsx from "clsx";
import React, { Dispatch, FC, SetStateAction } from "react";

import { areFormFiltersEmpty } from "../../utils/exhibitions";
import { Button } from "../buttons/button";
import { Select } from "../forms";
import { Icon } from "../icon";
import { ExhibitionFiltersPanel, ExhibitionFiltersPanelProps } from "./exhibition-filters-panel";
import { ExhibitionFiltersSummary } from "./exhibition-filters-summary";
import { ExhibitionFinderFiltersFormTypes, ExhibitionTimeFilter } from "./types";

export interface ExhibitionFinderHeaderProps {
  appliedFilters: ExhibitionFinderFiltersFormTypes;
  exhibitions: Queries.ExhibitionCardDataFragment[];
  labels: {
    "exhibition-finder-header-filter": string;
  } & ExhibitionFiltersPanelProps["labels"];
  isFiltersPanelOpen: boolean;
  setFiltersPanelOpen: Dispatch<SetStateAction<boolean>>;
  setAppliedFilters: Dispatch<SetStateAction<ExhibitionFinderFiltersFormTypes>>;
}

export const ExhibitionFinderHeader: FC<ExhibitionFinderHeaderProps> = ({
  labels,
  isFiltersPanelOpen,
  setFiltersPanelOpen,
  setAppliedFilters,
  appliedFilters,
  exhibitions,
}) => {
  const shouldShowSummary = !areFormFiltersEmpty(appliedFilters);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <Button
          type="button"
          variant="primary"
          size="sm"
          className="flex gap-1 items-center"
          onClick={() => setFiltersPanelOpen((isOpen) => !isOpen)}
        >
          {labels["exhibition-finder-header-filter"]}
          <Icon icon="filter" className="text-light w-5 pt-1/2" />
        </Button>

        <Select
          value={appliedFilters.time}
          onChange={(e) => {
            setAppliedFilters((filters) => ({
              ...filters,
              time: Object.values<string>(ExhibitionTimeFilter).includes(e.target.value)
                ? (e.target.value as ExhibitionTimeFilter)
                : ExhibitionTimeFilter.ALL,
            }));
          }}
          className="flex-none"
        >
          <option value={ExhibitionTimeFilter.ALL}>
            {labels["exhibition-finder-panel-option-all"]}
          </option>
          <option value={ExhibitionTimeFilter.PAST}>
            {labels["exhibition-finder-panel-past-exhibitions"]}
          </option>
          <option value={ExhibitionTimeFilter.FUTURE_OR_ONGOING}>
            {labels["exhibition-finder-panel-future-or-ongoing-exhibitions"]}
          </option>
        </Select>
      </div>

      <div className="overflow-y-hidden w-full">
        <ExhibitionFiltersPanel
          exhibitions={exhibitions}
          isOpen={isFiltersPanelOpen}
          setOpen={setFiltersPanelOpen}
          labels={labels}
        />
      </div>

      <div
        className={clsx(
          "duration-300 transition-all overflow-y-hidden",
          shouldShowSummary ? "max-h-[100vh]" : "max-h-0"
        )}
      >
        <ExhibitionFiltersSummary
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          labels={labels}
        />
      </div>
    </div>
  );
};
